import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const root = css`
  display: flex;
  direction: ltr;
`

export const select = css`
  margin-right: ${styles.size[16]};
  min-width: 110px;
  flex: 1;
`

export const input = css`
  flex: 3;
`

export const direction = css`
  direction: ltr;
`

export const startAdornment = css`
  margin: 0;
  margin-right: ${styles.size[8]};
`
